import { gql } from '@apollo/client';

export const GET_USERS_LIST = gql`
query GetUsers ($pageSize: Int!, $pageOffset: Int!, $order_by: [user_order_by], $searchText: String = "%") {
  user(where: {_or:[{u_email_id:{_ilike:$searchText}},{u_full_name:{_ilike:$searchText}},{user_referred_to:{ur_joining_code:{_ilike:$searchText}}}],u_deleted_at:{_is_null:true},u_role:{_eq:"user"}}, offset: $pageOffset, limit: $pageSize, order_by: $order_by) {
    u_id
    u_country_code
    u_created_at
    u_email_id
    u_first_name
    u_is_active
    u_last_name
    u_last_online
    u_phone_number
    u_full_name
    u_is_verified
    u_total_earnings
    tickets_sold_amount
    u_stripe_account_id
    u_delete_requested
    u_stripe_dba_name
    u_stripe_business_name
    tickets_aggregate {
      aggregate {
        sum {
          t_active_tickets
          t_sold_tickets
        }
      }
    }
    user_referred_to {
      ur_joining_code
      user_referred_by {
        u_full_name
        u_first_name
        u_last_name
      }
    }
    user_referred_by_aggregate(where: {user_referred_to:{u_deleted_at:{_is_null:true}}}) {
      aggregate {
        count
      }
    }
  }
  user_aggregate(where: {_or:[{u_email_id:{_ilike:$searchText}},{u_full_name:{_ilike:$searchText}},{user_referred_to:{ur_joining_code:{_ilike:$searchText}}}],u_deleted_at:{_is_null:true},u_role:{_eq:"user"}}) {
    aggregate {
      count
    }
  }
}
`;

export const UPDATE_USER = gql`
mutation UpdateUserActivityStatus ($userStatusInput: UserStatusInput!) {
  updateUserActivityStatus(userStatusInput: $userStatusInput) {
    message
  }
}
`;

export const SEND_VERIFICATION = gql`
mutation VerifySignupCodeLink ($verifyUserInput: [verifyUserInput]!) {
  sendVerificationCodeLink(sendVerificationCodeLinkInput: {verifyUserInput:$verifyUserInput}) {
    message
  }
}
`;

export const GET_MARKETING_USERS = gql `
    query GetMarketingUsers ($pageSize: Int, $pageOffset: Int, $order_by: [user_order_by], $searchText: String = "%") {
            user: get_marketing_users(where: {_or:[{u_email_id:{_ilike:$searchText}},{u_full_name:{_ilike:$searchText}},{user_referred_to:{ur_joining_code:{_ilike:$searchText}}}],u_deleted_at:{_is_null:true},u_role:{_eq:"user"}}, offset: $pageOffset, limit: $pageSize, order_by: $order_by) {
              u_id
              u_country_code
              u_created_at
              u_email_id
              u_first_name
              u_is_active
              u_last_name
              u_last_online
              u_phone_number
              u_full_name
              u_is_verified
              u_total_earnings
              tickets_sold_amount
              u_stripe_account_id
              u_delete_requested
              user_referred_to {
                ur_joining_code
                user_referred_by {
                  u_full_name
                  u_first_name
                  u_last_name
                }
              }
              tickets_aggregate {
                aggregate {
                  sum {
                    t_active_tickets
                    t_sold_tickets
                  }
                }
              }
              user_referred_by_aggregate(where: {user_referred_to:{u_deleted_at:{_is_null:true}}}) {
                aggregate {
                  count
                }
              }
            }
            user_aggregate: get_marketing_users_aggregate(where: {_or:[{u_email_id:{_ilike:$searchText}},{u_full_name:{_ilike:$searchText}},{user_referred_to:{ur_joining_code:{_ilike:$searchText}}}],u_deleted_at:{_is_null:true},u_role:{_eq:"user"}}) {
              aggregate {
                count
              }
            }
          }
`;

export const ADD_REFERRED_BY = gql `mutation addReferredBy ($userId: uuid!, $userReferralId: uuid!) {
  add_referred_by(args: {userid:$userId,userreferralid:$userReferralId}) {
    u_id
    u_full_name
  }
}`;
